//引入react jsx写法的必须
import React, {Suspense, useEffect, useState} from 'react';
import {Navigate, useLocation, useNavigate, useParams} from "react-router-dom";
// 引入路由配置
import { routes } from "./config";
//引入一些模块
import {Routes, Route} from "react-router-dom";
import ELoading from "../components/CommonComponents/ELoading/ELoading";
import {fromShare, getCompanyName} from "../api/apis";
import {getParams} from "../plugins/constantFunction";

// 路由级权限守卫：当路由 meta.allowOrgIds 存在时，校验当前公司 orgId 是否在白名单内
// 分享链接(fromShare)走后台校验，不做公司限制
function RouteGuard({ meta, children }) {
  const { pid } = useParams();
  const allowOrgIds = meta && meta.allowOrgIds;
  const needCheck = !!allowOrgIds && pid !== "fromShare";
  // null：校验中；true：放行；false：拦截
  const [passed, changePassed] = useState(needCheck ? null : true);

  useEffect(() => {
    if (!needCheck) return;
    changePassed(null);
    let isMounted = true;
    getCompanyName().then(res => {
      if (!isMounted) return;
      const orgId = (res && res.result) ? Number(res.result.orgId) : 0;
      changePassed(allowOrgIds.includes(orgId));
    }).catch(() => {
      if (isMounted) changePassed(false);
    });
    return () => { isMounted = false; };
  }, [needCheck]);

  if (passed === null) return <ELoading />;
  if (passed) return children;
  // 无权限：跳回首页
  return <Navigate replace to="/home" />;
}

function Router(){
  const url = useLocation();
  const navigate = useNavigate();

  const [urlParams, changeUrlParams] = useState(getParams(url.search));
  useEffect(() => {
    // 从太行启翼菜单，固定qiyip1存放token
    if(urlParams && urlParams.qiyip1) {
      window.localStorage.setItem("ecube_accessToken", urlParams.qiyip1)
      navigate("/", { replace: true })
    }

    // 从已发布链接进入，在跳转链接上带上固定shareUid，此时不需要token
    if(urlParams && urlParams.shareUid) {
      fromShare({shareUid: urlParams.shareUid}).then(res => {
        if(res.status === 0) {
          if(res.result === 1) {
            navigate(`/project/screen1/fromShare?shareUid=${urlParams.shareUid}`, { replace: true })
          } else if(res.result === 2) {
            navigate(`/project/screen2/fromShare?shareUid=${urlParams.shareUid}`, { replace: true })
          } else if(res.result === 3) {
            navigate(`/project/screen3/fromShare?shareUid=${urlParams.shareUid}`, { replace: true })
          } else if(res.result === 4) {
            navigate(`/project/screen4/fromShare?shareUid=${urlParams.shareUid}`, { replace: true })
          } else if(res.result === 5) {
            navigate(`/project/screen5/fromShare?shareUid=${urlParams.shareUid}`, { replace: true })
          } else if(res.result === 6) {
            navigate(`/project/screen6/fromShare?shareUid=${urlParams.shareUid}`, { replace: true })
          } else if(res.result === 7) {
            navigate(`/project/screen7/fromShare?shareUid=${urlParams.shareUid}`, { replace: true })
          }
        }
      })
    }
  }, [])

  return (
    <Routes>
      {
        routes.map(router => {
          return (
            <Route
              key={router.name}
              path={router.path}
              element={
                // <Suspense fallback={<div>正在加载...</div>}>
                <Suspense fallback={<ELoading />}>
                  <RouteGuard meta={router.meta}>
                    <router.component />
                  </RouteGuard>
                </Suspense>
              }
            >
            </Route>
          )
        })
      }
      <Route path="/" element={ <Navigate replace to="/home" />  } />
    </Routes>
  );
}

export default Router;
